// extracted by mini-css-extract-plugin
export default {"progressContainer":"PageProgressBar_progressContainer__s-jSj","progressValue":"PageProgressBar_progressValue__3Y2DW"};